<template>
    <picture :class="blure ? 'blure' : ''">
        <source media="(-webkit-min-device-pixel-ratio: 2) and (max-width: 414px)" :srcset="imageUrl" />
        <img v-if="imageUrl" :src="imageUrl" :alt="imageAlt" @error="setAltImg" loading="lazy" />
        <img v-else src="/nuxt-assets/images/lazy-load-error.svg" :alt="imageAlt" loading="lazy" />
    </picture>
</template>

<script>
export default {
    props: {
        imageUrl: {
            type: String,
            default: '/nuxt-assets/images/lazy-load-error.svg',
            required: false,
        },
        imageAlt: {
            type: String,
            default: 'Product image',
            required: false,
        },
        blure: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        setAltImg(event) {
            event.target.src = '/nuxt-assets/images/lazy-load-error.svg'
        },
    },
}
</script>
<style lang="scss" scoped>
picture {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &.blure {
        -webkit-filter: blur(11px); /* Safari 6.0 - 9.0 */
        filter: blur(11px);
    }
}
</style>
